import POIStep from "@/components/POI/POIStep/POIStep.vue";
import PoiOplocFields from "@/components/POI/POIStateFields/PoiOplocFields/PoiOplocFields.vue";

export default {
  components: { PoiOplocFields, POIStep },
  props: ["step", "position", "editedItem", "isOwnedBySubPrincipal"],
  methods: {
    changeStep(position) {
      this.$emit("changeStep", position);
    },
    saveHelper() {
      this.$emit("save", false);
    }
  }
};
